import React from 'react';

const ContentLoader = ({ message = 'Loading...' }) => {
  return (
    <div className="relative min-h-[300px] flex items-center justify-center">
      {/* Overlay only inside content */}
      <div className="absolute inset-0 bg-gray-100 flex flex-col items-center justify-center z-10">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-orange-500"></div>
        <p className="mt-3 text-sm text-gray-600">{message}</p>
      </div>
    </div>
  );
};

export default ContentLoader;
